const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
export {
  Blob$1 as default
};
